import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import ContentAccessTypeTag from 'ui-memberships-settings-lib/components/ContentAccessTypeTag';
import StateConstants from '../constants/StateConstants';
import { selectMembershipSsoEnabledForDomain } from '../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppSelector } from '../utils/hooks';
import { getLegacyArticlePayload } from '../utils/articleVisibilityUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ArticleHeaderBadges = ({
  articleState,
  archived,
  accessRuleIds,
  accessRuleType,
  className
}) => {
  const {
    publicAccessRules,
    publicAccessRulesEnabled
  } = getLegacyArticlePayload({
    hs_access_rule_ids: accessRuleIds,
    hs_access_rule_type: accessRuleType
  });
  const isSSOEnabled = useAppSelector(selectMembershipSsoEnabledForDomain);
  const portalHasRestrictContentAccess = useAppSelector(state => state.knowledgeScopes.canRestrictContent);
  const renderTag = _articleState => {
    if (!_articleState) {
      return null;
    }
    return /*#__PURE__*/_jsx(UITag, {
      use: _articleState === StateConstants.ARCHIVED ? 'default' : _articleState.toLowerCase(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `knowledgeContentUI.shared.articleStates.${_articleState}`
      })
    });
  };
  const renderRestrictedContentTag = () => {
    return /*#__PURE__*/_jsx(ContentAccessTypeTag, {
      className: "m-left-2",
      shouldRender: portalHasRestrictContentAccess,
      isSSOEnabled: isSSOEnabled,
      publicAccessRules: publicAccessRules,
      publicAccessRulesEnabled: publicAccessRulesEnabled
    });
  };
  if (!articleState) {
    return null;
  }
  return /*#__PURE__*/_jsxs("span", {
    className: className,
    children: [renderTag(articleState), archived && renderTag(StateConstants.ARCHIVED), renderRestrictedContentTag()]
  });
};
export default ArticleHeaderBadges;